import { FC, useState } from 'react';
import { useFormRef } from 'pages/PasswordReset/useFormRef';
import usePost from 'src/hooks/usePost';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const UpdatePassword: FC<{ token: string }> = ({ token }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { formRef, isValid, checkValidity, onSubmit } = useFormRef();
	const { invalidateError, loading, makeRequest } = usePost();
	const [isPasswordChanged, setIsPasswordChanged] = useState(false);

	const handleChangePassword = async (body?: Record<string, any>) => {
		invalidateError();
		const data = await makeRequest('users/password/reset', false, { ...body, token });
		if (!data) {
			setIsPasswordChanged(true);
		}
	};
	return <form ref={formRef} className={'password-reset-form'}>
		{isPasswordChanged ?
			<>
				<p>{t("pages.forgotPassword.passwordChanged")}</p>
				<button
					className={'scroll-to-button active'}
					type="submit"
					onClick={()=> navigate("/en/login")}
					disabled={!isValid || loading}
				>
					{t("pages.forgotPassword.goToLogin")}
				</button>
			</>
			:
			<>
				<p>{t("pages.forgotPassword.enterAndConfirmPassword")}</p>
				<span>{t("errors.password_length")}</span>
				<input
					name="password"
					placeholder={t('pages.signup.password')}
					disabled={loading}
					type="password"
					minLength={6}
					onInput={checkValidity}
					required
				/>
				<input
					name="passwordConfirm"
					placeholder={t('pages.signup.confirmPassword')}
					disabled={loading}
					type="password"
					minLength={6}
					onInput={checkValidity}
					required
				/>
				<button
					className={'scroll-to-button active'}
					type="submit"
					onClick={onSubmit(handleChangePassword)}
					disabled={!isValid || loading}
				>
					{t("pages.forgotPassword.resetPassword")}
				</button>
			</>}

	</form>;
};
